import React, { useEffect, useState } from "react";
import { authApi } from "../auth/authApi";
import { Link } from "react-router-dom";
import logo from "../assets/img/boersenkusecpixabay.png";
import "./login.css";

export default function ConfirmRegistrationPage() {
    const [status, setStatus] = useState("loading");

    useEffect(() => {
        const confirm = async () => {
            try {
                const token = new URLSearchParams(window.location.search).get("token");

                if (!token) {
                    setStatus("error");
                    return;
                }

                await authApi.confirmRegistration(token);
                setStatus("success");
            } catch {
                setStatus("error");
            }
        };

        confirm();
    }, []);

    return (
        <div className="login-root">
            <div className="login-left">
                <img src={logo} alt="Logo" className="login-logo" />
                <span className="company-name">
                    Künstliche-Intelligenz-Marktanalyse-Terminal
                </span>
            </div>

            <div className="login-divider" />

            <div className="login-right">
                {status === "loading" && (
                    <>
                        <h1>Bestätigung läuft</h1>
                        <p>Ihre Registrierung wird gerade geprüft und aktiviert.</p>
                        <div className="login-success">Bestätigung läuft ...</div>
                    </>
                )}

                {status === "success" && (
                    <>
                        <h1>Erstanmeldung bestätigt</h1>
                        <p>Ihr Zugang wurde erfolgreich aktiviert.</p>

                        <div className="login-success">
                            Die E-Mail-Adresse wurde erfolgreich bestätigt. Sie können sich jetzt anmelden.
                        </div>

                        <div className="login-links">
                            <Link to="/login" className="login-link">
                                Zur Anmeldung
                            </Link>
                        </div>
                    </>
                )}

                {status === "error" && (
                    <>
                        <h1>Bestätigung fehlgeschlagen</h1>
                        <p>Der Bestätigungslink ist ungültig, unvollständig oder bereits abgelaufen.</p>

                        <div className="login-error">
                            Die Registrierung konnte nicht bestätigt werden.
                        </div>

                        <div className="login-links">
                            <Link to="/register" className="login-link">
                                Neue Erstanmeldung
                            </Link>
                            <Link to="/login" className="login-link">
                                Zur Anmeldung
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}